import React, { useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Breadcrumbs,
} from "@mui/material";
import {
  Settings,
  Timelapse,
  AddTask,
  HolidayVillage,
  Savings,
  CreditScore,
  EnergySavingsLeaf,
  SettingsAccessibility,
  PermIdentity,
} from "@mui/icons-material";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
// configuration files
import { Leaves } from "./Leaves";
import { Permissions } from "./Permission";
import { Loans } from "./Loan";
import { Expense } from "./Expense";
import { AdvanceSalary } from "./AdvanceSalary";
import { WeekOff } from "./WeekOff";
import { Incentive } from "./Incentive";
import { MyAOvertimePreApproval } from "./Overtime/OvertimePreApproval";
import { MyAOvertimeApproval } from "./Overtime/OvertimeApproval";
import { themes } from "services/constants";
import { FilterProvider } from "../../FilterContext";
import { setFilterApi } from "services/Redux/userManagament";
import { theme } from "services/constants";

const shiftSidebarWidth = 280;

export const MyZoneApply = () => {
  const [selectedItem, setSelectedItem] = useState("OT Pre-Approval");
  const sideBarOpen = true;
  const [showFullPage, setShowFullPage] = useState(false);
  const { domain, userScreenAccess, userDetails } = useSelector(
    (state) => state.tokenReducer,
  );
  const dispatch = useDispatch();
  const shiftModule = userScreenAccess?.module_details.find(
    (mod) => mod.module_name === "Apply",
  );

  const subModuleId = shiftModule?.submodules?.find(
    (sub) => sub.sub_module_name === selectedItem,
  )?.sub_module_id;

  const shiftMenuItems = [
    { type: "tile", title: "Attendance Request" },
    {
      type: "item",
      title: "Leaves",
      key: "Leaves",
      subtitle: "Apply for leave",
      icon: <HolidayVillage />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Permissions",
      key: "Permissions",
      subtitle: "Request short permission",
      icon: <PermIdentity />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "OT Pre-Approval",
      key: "OT Pre-Approval",
      subtitle: "Request overtime",
      icon: <Timelapse />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "DayOff",
      key: "DayOff",
      subtitle: "Request day off",
      icon: <SettingsAccessibility />,
      color: "#6c757d",
    },

    { type: "tile", title: "Payroll Request" },
    {
      type: "item",
      title: "OT Post-Approval",
      key: "OT Post-Approval",
      subtitle: "Review Overtime requests",
      icon: <AddTask />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Advance Salary",
      key: "Advance Salary",
      subtitle: "Request salary in advance",
      icon: <Savings />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Loans",
      key: "Loans",
      subtitle: "View loan details",
      icon: <CreditScore />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Expense",
      key: "Expense",
      subtitle: "Submit expenses",
      icon: <EnergySavingsLeaf />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Incentive",
      key: "Incentive",
      subtitle: "View incentives",
      icon: <Settings />,
      color: "#6c757d",
    },
  ];

  const handleShiftItemClick = (itemTitle) => {
    setSelectedItem(itemTitle);
    dispatch(setFilterApi(true));
    setShowFullPage(false);
  };

  const renderMainContent = () => {
    switch (selectedItem) {
      case "Leaves":
        return (
          <Leaves
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
          />
        );
      case "Permissions":
        return <Permissions setSelectedItem={setSelectedItem} />;
      case "Loans":
        return (
          <Loans
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
          />
        );
      case "Expense":
        return (
          <Expense
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
          />
        );
      case "Advance Salary":
        return (
          <AdvanceSalary
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
          />
        );
      case "DayOff":
        return (
          <WeekOff
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
          />
        );
      case "Incentive":
        return (
          <Incentive
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
          />
        );
      case "OT Pre-Approval":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <MyAOvertimePreApproval />
          </FilterProvider>
        );
      case "OT Post-Approval":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <MyAOvertimeApproval />
          </FilterProvider>
        );
      default:
        return null;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          height: "94.5vh",
          backgroundColor: themes?.whiteColor,
        }}
      >
        <Box
          sx={{
            width: sideBarOpen ? shiftSidebarWidth : 0,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            flexShrink: 0,
            mt: "10px",
            backgroundColor: themes?.whiteColor,
            borderRight: "1px solid #f5f5fd",
          }}
        >
          <List sx={{ p: 2 }}>
            {shiftMenuItems.map((item, index) =>
              item.type === "tile" ? (
                <Typography
                  key={`tile-${index}`}
                  variant="subtitle"
                  sx={{ fontWeight: 700, color: "#00D4AA", mt: 2, mb: 2 }}
                >
                  {item.title}
                </Typography>
              ) : (
                <ListItem key={item.title} disablePadding sx={{ mb: 1, mt: 1 }}>
                  <ListItemButton
                    onClick={() => handleShiftItemClick(item.key)}
                    sx={{
                      backgroundColor:
                        selectedItem === (item.key ?? item.groupKey)
                          ? "#f0f8ff"
                          : "transparent",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "38px",
                        color:
                          selectedItem === item.key ? "#00D4AA" : item.color,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        {item.subtitle}
                      </Typography>
                    </Box>
                  </ListItemButton>
                </ListItem>
              ),
            )}
          </List>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            minWidth: 0,
            backgroundColor:
              selectedItem === "OT Pre-Approval" ||
              selectedItem === "OT Post-Approval"
                ? "#f5f5fd"
                : "transparent",
            transition: "all 0.3s ease",
          }}
        >
          {(selectedItem === "OT Pre-Approval" ||
            selectedItem === "OT Post-Approval") &&
            sideBarOpen &&
            !showFullPage && (
              <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
                <Typography>My Zone</Typography>
                <Typography>Apply</Typography>
                <Typography color={themes?.blueColor}>
                  {selectedItem}
                </Typography>
              </Breadcrumbs>
            )}

          {renderMainContent()}
        </Box>
      </Box>
    </ThemeProvider>
  );
};
